const devSubDomains: string[] = ['localhost', 'dev', 'develop', 'staging', 'pr-', 'approvals'];

export default devSubDomains;
